module.exports = __webpack_public_path__ + "img/m-hd.18d1bf01.jpg";